// extracted by mini-css-extract-plugin
export default {"the_copyright":"TheCopyright_the_copyright__9hARo"};